var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00099 12.0009L12.001 6.00093M8.00099 3.00093L8.46399 2.46493C8.9283 2.0005 9.47955 1.63208 10.0863 1.38073C10.693 1.12937 11.3433 1 12 1C12.6567 1 13.307 1.12937 13.9137 1.38073C14.5204 1.63208 15.0717 2.0005 15.536 2.46493C16.0012 2.92884 16.3703 3.47999 16.6221 4.08681C16.8739 4.69362 17.0034 5.34416 17.0033 6.00114C17.0032 6.65812 16.8735 7.30862 16.6215 7.91536C16.3696 8.52211 16.0003 9.07316 15.535 9.53693M9.60399 15.5349C8.65498 16.4726 7.37462 16.9985 6.04049 16.9985C4.70636 16.9985 3.42599 16.4726 2.47699 15.5349C2.0091 15.0727 1.63762 14.5221 1.38409 13.9152C1.13055 13.3083 1 12.6572 1 11.9994C1 11.3417 1.13055 10.6905 1.38409 10.0836C1.63762 9.47673 2.0091 8.9262 2.47699 8.46393L3.00099 8.00093M13.001 16.0009H19.001M16.001 13.0009V19.0009",
    stroke: "#04BA96",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.c46bb492fafe7ea05fec1a348aff36f3.svg";
export { ForwardRef as ReactComponent };